import type { AiSetupContract, AiPreference } from "../shared/connect-ai";

export async function fetchAiSetup(): Promise<AiSetupContract> {
  const response = await fetch("/api/connect/ai");
  if (!response.ok) {
    throw new Error("Failed to load AI setup");
  }
  return response.json();
}

export async function saveAiPreference(params: {
  preferredSource: AiPreference;
  limitedModeConfirmed?: boolean;
}): Promise<void> {
  const response = await fetch("/api/connect/ai/preference", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    throw new Error("Failed to save AI preference");
  }
}
